import { Getters } from 'vuex-smart-module';
import GlobalState from './state';

export default class GlobalGetters extends Getters<GlobalState> {}
